export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-arrow-right-7aeb130a47b485c78b467d916f3a43c3.svg";